import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { QrcodeComponent as CoreQrcodeComponent } from '@core/lib/components/qrcode/qrcode.component';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss'],
  imports: [
    CoreQrcodeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrcodeComponent {

  public readonly content = input.required<string>();
  public readonly variant = input<'black' | 'white'>('black');
  public readonly logo = input<string | null>(null);
  public readonly size = input<number>(200);

}
